// Constant: Settings > Default color
const DEFAULT_COLOR = 'green'

// Constant: Settings > Default color in hex
const DEFAULT_COLOR_IN_HEX = '#2dd27d'

// Constant: Settings > Default intent
const DEFAULT_INTENT = 'information'

// Constant: Settings > Default locale
const DEFAULT_LOCALE = 'en_US'

// Constant: Settings > Default size
const DEFAULT_SIZE = 'medium'

// Constant: Settings > Default theme
const DEFAULT_THEME = 'dark'

// Export
export {
  DEFAULT_COLOR,
  DEFAULT_COLOR_IN_HEX,
  DEFAULT_INTENT,
  DEFAULT_LOCALE,
  DEFAULT_SIZE,
  DEFAULT_THEME
}
